module.exports = __webpack_public_path__ + "img/Facebook.19cdffd9.svg";